const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
/* Glimbooth Motion Pack v1.0
   Shopify Refresh theme
   Add as: assets/glim-motion.js
*/

(() => {
  const SELECTORS = {
    main: '#MainContent',
    sections: '#MainContent > .shopify-section',
    cards: [
      '.card-wrapper',
      '.product-card-wrapper',
      '.collection-card-wrapper',
      '.multicolumn-card',
      '.glim-review-card',
      '[class*="review-card"]'
    ].join(','),
    images: [
      '.banner__media img',
      '.image-with-text__media img',
      '.multicolumn-card__image',
      '.media img'
    ].join(','),
    headings: '#MainContent h1, #MainContent h2'
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let parallaxItems = [];
  let ticking = false;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function initSections(main) {
    const sections = [...document.querySelectorAll(SELECTORS.sections)];

    sections.forEach((section, index) => {
      if (index === 0 || section.dataset.glimRevealReady === 'true') return;

      section.dataset.glimRevealReady = 'true';
      section.classList.add('glim-section-reveal');
    });

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('glim-is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -7% 0px'
      }
    );

    main.querySelectorAll('.glim-section-reveal:not(.glim-is-visible)')
      .forEach(section => observer.observe(section));
  }

  function initHeadings(main) {
    const headings = main.querySelectorAll(SELECTORS.headings);

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('glim-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    headings.forEach(heading => {
      if (heading.dataset.glimHeadingReady === 'true') return;

      const hasComplexMarkup = heading.querySelector('a, img, svg, br');
      const text = heading.textContent.trim();

      if (!text || hasComplexMarkup) return;

      heading.dataset.glimHeadingReady = 'true';
      heading.classList.add('glim-heading-reveal');

      const span = document.createElement('span');
      span.className = 'glim-heading-inner';
      span.textContent = text;

      heading.textContent = '';
      heading.appendChild(span);
      observer.observe(heading);
    });
  }

  function initCards(main) {
    main.querySelectorAll(SELECTORS.cards).forEach(card => {
      if (card.dataset.glimCardReady === 'true') return;

      card.dataset.glimCardReady = 'true';
      card.classList.add('glim-tilt-card');

      card.addEventListener('pointermove', event => {
        if (reduceMotion.matches || window.innerWidth < 750) return;

        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const x = clamp((event.clientX - rect.left) / rect.width, 0, 1);
        const y = clamp((event.clientY - rect.top) / rect.height, 0, 1);

        card.style.setProperty('--glim-rx', `${(0.5 - y) * 7}deg`);
        card.style.setProperty('--glim-ry', `${(x - 0.5) * 7}deg`);
        card.style.setProperty('--glim-light-x', `${x * 100}%`);
        card.style.setProperty('--glim-light-y', `${y * 100}%`);
      });

      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--glim-rx', '0deg');
        card.style.setProperty('--glim-ry', '0deg');
      });
    });
  }

  function initImages(main) {
    parallaxItems = [];

    main.querySelectorAll(SELECTORS.images).forEach(image => {
      if (image.closest('.glim-tilt-card')) return;

      const wrapper = image.closest(
        '.banner__media, .image-with-text__media, .media'
      );

      if (!wrapper) return;

      wrapper.classList.add('glim-parallax-wrap');
      image.classList.add('glim-parallax-image');

      parallaxItems.push({ image, wrapper });
    });
  }

  function updateParallax() {
    ticking = false;

    if (reduceMotion.matches || window.innerWidth < 750) {
      parallaxItems.forEach(({ image }) => {
        image.style.removeProperty('--glim-parallax-y');
      });
      return;
    }

    const viewportHeight = window.innerHeight;

    parallaxItems.forEach(({ image, wrapper }) => {
      const rect = wrapper.getBoundingClientRect();

      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const center = rect.top + rect.height / 2;
      const distance = (center - viewportHeight / 2) / viewportHeight;
      const offset = clamp(distance * -28, -22, 22);

      image.style.setProperty('--glim-parallax-y', `${offset}px`);
    });
  }

  function requestParallaxUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }

  function initAmbientOrb() {
    if (document.querySelector('.glim-ambient-orb')) return;

    const orb = document.createElement('div');
    orb.className = 'glim-ambient-orb';
    orb.setAttribute('aria-hidden', 'true');
    document.body.appendChild(orb);

    document.addEventListener(
      'pointermove',
      event => {
        if (reduceMotion.matches || window.innerWidth < 750) return;
        orb.style.left = `${event.clientX}px`;
        orb.style.top = `${event.clientY}px`;
      },
      { passive: true }
    );
  }

  function initMotionPack() {
    const main = document.querySelector(SELECTORS.main);
    if (!main) return;

    initSections(main);
    initHeadings(main);
    initCards(main);
    initImages(main);
    initAmbientOrb();
    requestParallaxUpdate();
  }

  document.addEventListener('DOMContentLoaded', initMotionPack);
  document.addEventListener('shopify:section:load', initMotionPack);

  window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
  window.addEventListener('resize', requestParallaxUpdate, { passive: true });

  if (document.readyState !== 'loading') {
    initMotionPack();
  }
})();